import React from 'react';
import Modal from 'react-modal';
import './ModalWindow.css';

export const ModalWindow = ({ modal, custom, children }) => (
      <Modal
          isOpen={modal}
          className='modal_content'
          overlayClassName='modal_overlay'
          style={custom}
      >
        {children}
      </Modal>
)



// WEBPACK FOOTER //
// ./src/components/atomic/organisms/ModalWindow/ModalWindow.js